<po-modal #poModalListItens class="modal-itens" [p-hide-close]="true" [p-click-out]="true"
    p-title="Lista de itens do pedido">
    <div class="po-pl-2 po-pr-2">
        <po-select name="select" p-label="Filtro localização" [ngModel]="itemSelectLocation"
            [p-options]="selectLocation" (p-change)="recoverLocationSelected($event)">
        </po-select>
        <po-table #countedItemsTable id="countedItemsTable" [p-height]="300" [p-items]="listModalLocationWithTotals"
            (p-sort-by)="onSortChange($event)" [p-columns]="countedItemsColumns" [p-sort]="true" [p-striped]="true">
        </po-table>
    </div>
</po-modal>

<div class="po-row">
    <div class="po-xl-10 po-lg-10 po-md-9 po-sm-9">
        <p class="po-font-title">Contagem</p>
    </div>
</div>
<div class="po-row po-mt-2 po-mb-1">
    <po-container class="po-xl-12 po-lg-12 po-md-12 po-sm-12">
        <div class="po-row po-pb-1" style="border-bottom: 1px solid #d3d3d3;">
            <div class="po-xl-10 po-lg-10 po-md-10 po-sm-10">
                <span class="po-text-color-01 po-font-text-bold">Descrição</span>
            </div>
            <div class="po-xl-2 po-lg-2 po-md-2 po-sm-2 po-text-right">
                <span class="po-text-color-01 po-font-text-bold" style="cursor: pointer;" (click)="seeDescription()">
                    <i *ngIf="seeDescriptionItens" class="an-fill an-caret-circle-up" style="font-size: 20px;"></i>
                    <i *ngIf="!seeDescriptionItens" class="an-fill an-caret-circle-down" style="font-size: 20px;"></i>
                </span>
            </div>
        </div>
        <div class="po-row" *ngIf="seeDescriptionItens">
            <div class="po-xl-12 po-lg-12 po-md-12 po-sm-12">
                <span class="po-font-text-smaller">Número</span>
                <po-input [ngModel]="orderCountModel.countCode" name="input" p-disabled="true"></po-input>
            </div>
            <div class="po-xl-12 po-lg-12 po-md-12 po-sm-12">
                <span class="po-font-text-smaller">Tipo embalagem</span>
                <po-input name="input" p-disabled="true"></po-input>
            </div>
            <div class="po-xl-12 po-lg-12 po-md-12 po-sm-12">
                <span class="po-font-text-smaller">Situação</span>
                <po-input [ngModel]="orderCountModel.countStatus.description" name="input" p-disabled="true"></po-input>
            </div>
            <div class="po-xl-12 po-lg-12 po-md-12 po-sm-12">
                <span class="po-font-text-smaller">Pedido</span>
                <po-input [ngModel]="orderModel.orderCode" name="input" p-disabled="true"></po-input>
            </div>
        </div>
    </po-container>
    <div #countCard style="height: 1px;width:1px;"></div>
    <po-container class="po-xl-12 po-lg-12 po-md-12 po-sm-12 po-mt-2">
        <div class="po-row po-pb-1" style="border-bottom: 1px solid #d3d3d3;">
            <div class="po-xl-12 po-lg-12 po-md-12 po-sm-12">
                <span class="po-text-color-01 po-font-text-bold">Contagem</span>
            </div>
        </div>
        <div class="po-row" [ngClass]="{ 'order-count-active': selectedMode }">
            <div class="po-pl-1 po-xl-12 po-lg-12 po-md-12 po-sm-12">
              <po-switch class="switch-remove" name="switch-remove" [(ngModel)]="selectedMode" 
                      p-label="Apagar ao ler código" p-label-on=" " p-label-off=" " [p-label-position]="labelPosition"
                      [p-disabled]="countInReadOnly()" (p-change)="onModeChange($event)">
              </po-switch>
            </div>
            <div class="po-xl-12 po-lg-12 po-md-12 po-sm-12">
                <span class="po-font-text-smaller">Quantidade</span>
                <po-input [ngModel]="quantityValue" p-icon="an an-list-numbers" name="input"
                    p-disabled="true"></po-input>
            </div>
            <app-scanner #scanner
                [disabled]="countInReadOnly()"
                (scannedData)="onScan($event)"
                class="po-xl-12 po-lg-12 po-md-12 po-sm-12 po-text-center">
            </app-scanner>
        </div>
    </po-container>
</div>
<po-container *ngIf="currentProduct" class="po-xl-12 po-lg-12 po-md-12 po-sm-12 po-mt-1 po-mb-2">
    <div class="po-row po-pb-1" style="border-bottom: 1px solid #d3d3d3;">
        <div class="po-xl-12 po-lg-12 po-md-12 po-sm-12">
            <span class="po-text-color-01 po-font-text-bold">Produto por localização</span>
        </div>
    </div>
    <div class="po-row">
        <div class="po-xl-1 po-lg-1 po-md-2 po-sm-12">
            <span class="po-font-text-smaller">Item</span>
            <po-input [ngModel]="productTotalizer" name="count" p-disabled="true"></po-input>
        </div>
        <div class="po-xl-11 po-lg-11 po-md-10 po-sm-12">
            <span class="po-font-text-smaller">Localização</span>
            <po-input [ngModel]="currentProduct.localDescription" name="input" p-disabled="true"></po-input>
        </div>
        <div class="po-xl-6 po-lg-6 po-md-6 po-sm-6">
            <po-button p-kind="primary" p-icon="an an-arrow-left" [p-disabled]="!hasPrevious" (p-click)="previousItem()"
                class="po-pl-0 po-xl-12 po-lg-12 po-md-12 po-sm-12 po-text-center"></po-button>
        </div>
        <div class="po-xl-6 po-lg-6 po-md-6 po-sm-6">
            <po-button p-kind="primary" p-icon="an an-arrow-right" [p-disabled]="!hasNext" (p-click)="nextItem()"
                class="po-pr-0 po-xl-12 po-lg-12 po-md-12 po-sm-12 po-text-center"></po-button>
        </div>
    </div>
    <div class="po-row po-mt-2">
        <po-widget class="po-lg-12 po-mb-1">
            <div class="po-row">
                <div class="po-xl-6 po-lg-6 po-md-6 po-sm-6">
                    <span class="po-text-color-01 po-font-text-bold">Grupo:</span>
                    <span class="po-ml-1">{{ currentProduct.groupCode }}</span>
                </div>
                <div class="po-xl-6 po-lg-6 po-md-6 po-sm-6">
                    <span class="po-text-color-01 po-font-text-bold">Produto:</span>
                    <span class="po-ml-1">{{ currentProduct.productCode }}</span>
                </div>
            </div>
            <div class="po-row po-pt-1">
                <div class="po-xl-12 po-lg-12 po-md-12 po-sm-12">
                    <span class="po-text-color-01 po-font-text-bold">Descrição:</span>
                    <span class="po-ml-1">{{ currentProduct.productDescription }}</span>
                </div>
            </div>
            <div class="po-row po-pt-2 po-text-center" style="color: white;">
                <div class="po-xl-6 po-lg-6 po-md-6 po-sm-6">
                    <div class="po-xl-12 po-lg-12 po-md-12 po-sm-12 po-color-01 po-p-1" style="border-radius: 5px;">
                        <span class="po-font-text-bold">Qtd. pendente:</span>
                        <span class="po-ml-1">{{ currentProduct.orderQuantity }}</span>
                    </div>
                </div>
                <div class="po-xl-6 po-lg-6 po-md-6 po-sm-6" style="border-radius: 5px;">
                    <div class="po-xl-12 po-lg-12 po-md-12 po-sm-12 po-color-01 po-p-1" style="border-radius: 5px;">
                        <span class="po-font-text-bold">Contagem atual:</span>
                        <span class="po-ml-1">{{ currentProduct.countQuantity }}</span>
                    </div>
                </div>
                <div class="po-xl-12 po-lg-12 po-md-12 po-sm-12 po-mt-2" style="border-radius: 5px;">
                    <div *ngIf="currentProduct.pendingQuantity > 0"
                        class="po-xl-12 po-lg-12 po-md-12 po-sm-12 po-color-07 po-p-1" style="border-radius: 5px;">
                        <span class="po-font-text-bold">Diferença:</span>
                        <span class="po-ml-1">{{ currentProduct.pendingQuantity }}</span>
                    </div>
                    <div *ngIf="currentProduct.orderQuantity === currentProduct.countQuantity"
                        class="po-xl-12 po-lg-12 po-md-12 po-sm-12 po-color-10 po-p-1" style="border-radius: 5px;">
                        <span class="po-font-text-bold">Contagem do item concluída</span>
                    </div>
                    <div *ngIf="currentProduct.countQuantity > currentProduct.orderQuantity"
                        class="po-xl-12 po-lg-12 po-md-12 po-sm-12 po-color-08 po-p-1" style="border-radius: 5px;">
                        <span class="po-font-text-bold">Contagem excedida:</span>
                        <span class="po-ml-1">{{ currentProduct.overCountQuantity }}</span>
                    </div>
                </div>
            </div>
        </po-widget>
    </div>
</po-container>
<div class="po-row po-pl-1 po-pr-1">
    <po-button p-kind="primary" p-label="Consultar Itens do Pedido" p-icon="an an-list-magnifying-glass"
        class="po-pl-0 po-pr-0 po-xl-12 po-lg-12 po-md-12 po-sm-12 po-text-center"
        (p-click)="openItemsModal()"></po-button>
    <po-button *ngIf="!countInReadOnly()" [p-disabled]="countInReadOnly()" p-kind="primary" p-label="Finalizar"
        p-icon="an an-check" class="po-mt-1 po-mb-3 po-pl-0 po-pr-0 po-xl-12 po-lg-12 po-md-12 po-sm-12 po-text-center"
        (p-click)="save()"></po-button>
</div>